import {
  InstructionDescription,
  InstructionTextWrapper,
  InstructionTitle,
} from './styled';

export interface InstructionTextProps {
  title?: string;
  description?: string;
}

export const InstructionText: React.FC<InstructionTextProps> = ({
  title,
  description,
}) => (
  <InstructionTextWrapper>
    <InstructionTitle>{title}</InstructionTitle>
    <InstructionDescription>{description}</InstructionDescription>
  </InstructionTextWrapper>
);
